module.exports = __webpack_public_path__ + "assets/images/help_screen02.png?";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_chatbot/help/help_screen02.png
// module id = 420
// module chunks = 0